module.exports = __webpack_public_path__ + "static/media/pwc-featured.0736fe8f.jpg";